"use client";

import { searchProducts } from "@/lib/api";
import { createStore } from "@/lib/store";
import { type Product, type ProductSearchRequest } from "@repo/schemas";

export type ProductsStore = {
  products: Product[];
  totalNbOfProducts: number;
  productsSearchParams: ProductSearchRequest;
};

export const {
  StoreProvider: ProductsProvider,
  StoreConsumer: ProductsConsumer,
  useSetters,
} = createStore<ProductsStore>()
  .addGetters({
    products: (store) => store.products,
    totalNbOfProducts: (store) => store.totalNbOfProducts,
    productsSearchParams: (store) => store.productsSearchParams,
    all: (store) => store,
  })
  .addSetters({
    setProducts(store, products: Product[], totalNbOfProducts: number) {
      store.products = products;
      store.totalNbOfProducts = totalNbOfProducts;
    },
    setProductsSearchParams(store, nextSearchParams: ProductSearchRequest) {
      store.productsSearchParams = nextSearchParams;
    },
  } as const)
  .addQueries({
    async searchProducts(store, payload: ProductSearchRequest) {
      const result = await searchProducts(payload);
      store.setProducts(result.data, result.totalCount);
    },
  });
